import { render, staticRenderFns } from "./Kanfang.vue?vue&type=template&id=46a65e28&scoped=true&"
import script from "./Kanfang.vue?vue&type=script&lang=js&"
export * from "./Kanfang.vue?vue&type=script&lang=js&"
import style0 from "./Kanfang.vue?vue&type=style&index=0&id=46a65e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a65e28",
  null
  
)

export default component.exports